import GooglePhotosProcessor from "../../frontend/js/EventgalleryGooglePhotosProcessor";

document.addEventListener('DOMContentLoaded', () =>{

    let googlePhotosProcessor = new GooglePhotosProcessor();
    googlePhotosProcessor.processImages();

});


